import { jsx as _jsx } from "react/jsx-runtime";
import { Box, unsafe_keyframes } from "@gemini/core";
import { LoaderIcon } from "@gemini/icons";
import { useTestId } from "@/hooks";
import { useI18n } from "@/shared/hooks";
export const Loading = () => {
    const { t } = useI18n();
    const spin = unsafe_keyframes({ to: { transform: "rotate(1turn)" } });
    const testId = useTestId("Loading");
    return (_jsx(Box, { as: "main", flex: "1 0 auto", minHeight: "100vh", paddingBottom: "20vh", display: "grid", gridTemplateRows: "1fr", placeItems: "center", role: "alert", "aria-live": "assertive", testId: testId, children: _jsx(LoaderIcon, { "aria-label": t("loading"), color: "inherit", size: "sizing.24", animationName: spin, animationDuration: "unsafe_component.button.motionDuration.spinner", animationTimingFunction: "unsafe_component.button.motionEasing.spinner", animationIterationCount: "infinite" }) }));
};
